// Copyright (c) 2026 杨翔宇（武汉文理学院）
// 物理智能教学智能体平台 (Physics Intelligent Agent)
// 保留所有权利 (All Rights Reserved)。未经著作权人书面许可，
// 不得以任何形式复制、传播、修改或用于商业用途。

import { createContext, useContext } from 'react';

import { EXISTING_SURFACE_POLICY, type AppSurfacePolicy } from './appSurfacePolicy';

/**
 * 当前页面渲染策略。缺省值恒为 `existing`——未包 Provider 的孤立组件（单测、
 * Storybook、未来新页面）保持既有行为，不会被工作区策略误伤。
 */
export const AppSurfaceContext = createContext<AppSurfacePolicy>(EXISTING_SURFACE_POLICY);

/** 读取当前页面渲染策略。 */
export function useAppSurfacePolicy(): AppSurfacePolicy {
  return useContext(AppSurfaceContext);
}
